import ProductCardWrapper from './ProductCardWrapper';

export default ProductCardWrapper;
